import UpdateFirmware from './UpdateFirmware'

export default UpdateFirmware
